import React, { useState } from "react";
import { Box } from "@mui/material";
import { cropStyle, useLogoInfo } from "../../utils/trimmedLogo";

export function teamInitials(name) {
  const words = String(name || "")
    .replace(/\bF\.?C\.?\b/gi, "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return "?";
  return (words.length === 1 ? words[0].slice(0, 2) : words[0][0] + words[1][0]).toUpperCase();
}

const inset = (size, ratio) => (typeof size === "number" ? `${size * ratio}px` : `${ratio * 100}%`);

/**
 * Team logo cropped to its artwork so every crest reads at the same size.
 * Mostly-white logos get a dark tile so they stay visible on white cards.
 */
export default function TeamCrest({ team, url, name, size = 32, sx }) {
  const logo = url ?? team?.logo_url ?? null;
  const label = name ?? team?.name ?? "";
  const info = useLogoInfo(logo);
  const [broken, setBroken] = useState(false);
  const box = { width: size, height: size, maxWidth: "100%", maxHeight: "100%", flexShrink: 0, boxSizing: "border-box", ...sx };

  if (!logo || broken) {
    return (
      <Box
        aria-hidden
        sx={{
          ...box,
          borderRadius: "50%",
          bgcolor: "#f0f0f1",
          color: "#6b6b70",
          fontWeight: 800,
          fontSize: typeof size === "number" ? Math.max(9, size * 0.34) : "0.9rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {teamInitials(label)}
      </Box>
    );
  }
  if (!info) return <Box aria-hidden sx={box} />;

  const img = <Box component="img" src={info.src} alt="" decoding="async" onError={() => setBroken(true)} sx={{ display: "block", ...cropStyle(info) }} />;
  if (!info.light) return <Box sx={{ ...box, position: "relative", overflow: "hidden" }}>{img}</Box>;
  return (
    <Box sx={{ ...box, bgcolor: "#18181b", borderRadius: "24%", padding: inset(size, 0.12) }}>
      <Box sx={{ position: "relative", width: "100%", height: "100%", overflow: "hidden" }}>{img}</Box>
    </Box>
  );
}

export function useTeamColor(url) {
  return useLogoInfo(url)?.color ?? null;
}
